/*
 * @Author: your name
 * @Date: 2021-07-09 14:18:19
 * @LastEditTime: 2021-07-09 18:41:43
 * @LastEditors: Song Xingyun
 * @Description: In User Settings Edit
 * @FilePath: /vue-modv/src/@core/utils/files.js
 */

/**
 * @description H5文件下咋子
 * @param url 下载链接
 * @returns
 */
export function savePicOnH5(url) {
  const Url = url
  // var triggerEvent = 'touchstart' // 指定下载方式
  const blob = new Blob([''], { type: 'application/octet-stream' }) // 二进制大型对象blob
  url = URL.createObjectURL(blob) // 创建一个字符串路径空位
  const a = document.createElement('a') // 创建一个 a 标签
  a.href = Url // 把路径赋到a标签的href上
  // 正则表达式，这里是把图片文件名分离出来。拿到文件名赋到a.download,作为文件名来使用文本
  a.download = Url.replace(/(.*\/)*([^.]+.*)/gi, '$2').split('?')[0]
  /* const e = document.createEvent('MouseEvents');  //创建事件（MouseEvents鼠标事件）
	    e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null); //初始化鼠标事件（initMouseEvent已弃用）*/
  // 代替方法。创建鼠标事件并初始化（后面这些参数我也不清楚，参考文档吧 https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/MouseEvent）
  const e = new MouseEvent('click', (true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null))
  // 派遣后，它将不再执行任何操作。执行保存到本地
  a.dispatchEvent(e)
  // 释放一个已经存在的路径（有创建createObjectURL就要释放revokeObjectURL）
  URL.revokeObjectURL(url)
}


export function blobProcess(res) {
  const { data, headers } = res
  const blob = new Blob([data])

  const fileName = getFileName()
  download(fileName, blob)

  function getFileName(encode = 'UTF-8') {
    const disposition = headers['content-disposition']
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    const matches = filenameRegex.exec(disposition)
    if (matches != null && matches[1]) {
      let s = matches[1].replace(/['"]/g, '')
      s = s.replace(encode, '')
      return decodeURI(s)
    }
    return 'notFoundFileName'
  }

  function download(filename, blob) {
    const elink = document.createElement('a')
    elink.download = filename
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href)
    document.body.removeChild(elink)
  }
}
